/**
 * Triggers a brief haptic feedback vibration if the browser supports it.
 * @param durationMs - The duration of the vibration in milliseconds. Defaults to 50ms.
 */
export const triggerVibration = (durationMs: number = 50): void => {
  if (navigator && typeof navigator.vibrate === 'function') {
    try {
      navigator.vibrate(durationMs);
    } catch (e) {
      // Silently catch potential errors, though usually not thrown
      console.warn('Haptic feedback failed:', e);
    }
  }
};
